<div class="content-wrapper">
  <ng-content select="asap-layout-navbar"></ng-content>

  <div class="main-content">
    <ng-content select="asap-layout-sidebar"></ng-content>

    <div class="main-content-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <ng-template [cdkPortalOutlet]="_portal"></ng-template>

            <ng-template [cdkPortalOutlet]="_popupPortal"></ng-template>
          </div>
        </div>
      </div>

      <!-- <ng-container *ngIf="_isOverlay || false">
      <div class="k-overlay"></div>
    </ng-container> -->

    @if (_isPopupOverlay) {
      <div class="k-overlay popup"></div>
    }

    <ng-content></ng-content>
  </div>


  @if (_isDialiog) {
    <asap-dialog-layout
      [data]="_dialogModel"
      [componentName]="_dialogComponentName"
      (closeDialog)="_closeDialog($event)">
    </asap-dialog-layout>
  }
</div>

</div>